var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// ./node_modules/enquire.js/src/index.js
// module id = 269
// module chunks = 0 1